// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"72a02b66","878":"93608507"}[chunkId] + ".chunk.css";
};